import {API_ANALYTICS_URL} from "config";
import {arahubAPI} from "config/axios";

const ROUTE = 'licence_plate';
const SUB_ROUTE = 'statisics'; // -> literówka 'statistics

const getLicencePlateByDate=async(query)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/by_dates`,{
            params:{
                date_from: query.date_from,
                date_to: query.date_to,
                device_id: query.device_id,
                region: query.region || 'Poland',
            }
        });
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
}

const getLicencePlateByDeviceIds=async(query)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/by_device_ids`,{
            params:{
                device_id: query.device_id,
            }
        });
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
}

const getLicencePlateStatisticsCount=async(query)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/${SUB_ROUTE}/count`,{
            params:{
                date_start: query.date_from,
                date_end: query.date_to,
                device_id: query.device_id,
                region: query.region || 'Poland',
            }
        });
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
}

const getLicencePlateStatisticsRegions=async(query)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/${SUB_ROUTE}/regions`,{
            params:{
                date_start: query.date_from,
                date_end: query.date_to,
                device_id: query.device_id,
                region: query.region || 'Poland',
            }
        });
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
}

const getLicencePlateStatisticsMeanStopTimeMinutes=async(query)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/${SUB_ROUTE}/mean_stop_time_minutes`,{
            params:{
                date_start: query.date_from,
                date_end: query.date_to,
                device_id: query.device_id,
                region: query.region || 'Poland',
            }
        });
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
}



const getLicencePlateReportRegionsCsv = async (query) => {
    try {
        const params = {
            date_start: query.date_from,
            date_end: query.date_to,
            region: query.region || 'Poland',
        };
        if (query.device_id !== undefined) params.device_id = query.device_id;
        const { data } = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/${SUB_ROUTE}/regions/csv`, {
            responseType: 'blob',
            params,
        });
        const href = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `licence_plates_regions_${query.date_from}_${query.date_to}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(href);
        return true;
    } catch (err) {
        return Promise.reject(err.response);
    }
};

const getLicencePlateReportCountPerHourCsv = async (query) => {
    try {
        const params = {
            date_start: query.date_from,
            date_end: query.date_to,
            region: query.region || 'Poland',
        };
        if (query.device_id !== undefined) params.device_id = query.device_id;
        const { data } = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/${SUB_ROUTE}/count_per_hour/csv`, {
            responseType: 'blob',
            params,
        });
        const href = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `licence_plates_count_per_hour_${query.date_from}_${query.date_to}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(href);
        return true;
    } catch (err) {
        return Promise.reject(err.response);
    }
};

const licencePlatesService = {
    getLicencePlateByDate,
    getLicencePlateByDeviceIds,
    getLicencePlateStatisticsCount,
    getLicencePlateStatisticsRegions,
    getLicencePlateStatisticsMeanStopTimeMinutes,
    getLicencePlateReportRegionsCsv,
    getLicencePlateReportCountPerHourCsv,
}

export default licencePlatesService;